import { render, staticRenderFns } from "./FoldableList.vue?vue&type=template&id=79b596e9&"
import script from "./FoldableList.vue?vue&type=script&lang=js&"
export * from "./FoldableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports